'use strict';

var _require = require('../mindash');

var extend = _require.extend;

function getHandlers(store) {
  return extend({}, store.handlers, store.constructor.handlers);
}

module.exports = getHandlers;


//////////////////
// WEBPACK FOOTER
// ./node_modules/marty-lib/modules/store/getHandlers.js
// module id = FZ2v
// module chunks = 88